<div class="grid col-12">
  <div class="col-12">
    <h2>Edit User</h2>
  </div>
  @if (messages.length > 0) {
    <div class="col-12">
      @for (m of messages; track m; let i = $index) {
        <p-message
          [severity]="m.severity"
          >{{ m.summary ? (m.detail ? m.summary + ': ' + m.detail : m.summary) : m.detail }}
        </p-message>
      }
    </div>
  }


  <ng-container>
    <div class="col-2">
      <label>Email</label>
    </div>
    <div class="col-10 p-inputgroup" >
      <input type="email" [disabled]="!isNew" pInputText placeholder="Enter Email Address"
        [(ngModel)]="user.email" (input)="validateEmail()" />
        <span class="p-inputgroup-addon" style="min-width: 50px;">
          <i class="far fa-envelope ml-2"></i>
        </span>
        <button pButton type="button" class="p-button-text"
          pTooltip="Copy Email" tooltipPosition="top"
          (click)="copyEmailToClipboard()" [disabled]="!user.email">
          <i pButtonIcon class="pi pi-copy"></i>
        </button>

        @if (modelInvalid && (!user.email || !userEmailValid)) {
          <div>
            <label style="color:red; font-weight:bold;">A Valid Email is required!</label>
          </div>
        }
      </div>

      <!-- First Name -->

      <div class="col-2">
        <label>First Name</label>
      </div>
      <div class="col-10">
        <input type="text" pInputText placeholder="Enter First Name" [(ngModel)]="user.firstName" />
        @if (modelInvalid && !user.firstName) {
          <div>
            <label style="color:red; font-weight:bold;">First Name is required!</label>
          </div>
        }
      </div>


      <!-- Last Name -->

      <div class="col-2">
        <label>Last Name</label>
      </div>
      <div class="col-10">
        <input type="text" pInputText placeholder="Enter Last Name" [(ngModel)]="user.lastName" />
        @if (modelInvalid && !user.lastName) {
          <div>
            <label style="color:red; font-weight:bold;">Last Name is required!</label>
          </div>
        }
      </div>

      <!--Contact Number-->

      <div class="col-2">
        <label>Contact Number</label>
      </div>
      <div class="col-10">
        <div class="p-inputgroup">
          <p-inputMask mask="(999) 999-9999" [(ngModel)]="user.contactNumber"
          placeholder="(999) 999-9999"></p-inputMask>
          <span class="p-inputgroup-addon">
            <i class="fa fa-phone ml-2"></i>
          </span>
        </div>

      </div>


      <div class="col-2">
        <label>Company Job Title</label>
      </div>
      <div class="col-10">
        <input type="text" pInputText placeholder="Enter Job Title" [(ngModel)]="user.companyJobTitle" />
      </div>


      @if (isAuthenticatedUserGlobalAdmin | async) {
        <div class="col-2">
          <label>Global Admin</label>
        </div>
        <div class="col-10">
          <p-checkbox
            binary="true"
            [(ngModel)]="user.isGlobalAdmin"
            label="Is Global Admin"
            inputId="globalAdminCheckbox"
            class="mr-2"
            [disabled]="!(isAuthenticatedUserGlobalAdmin | async)"
          ></p-checkbox>
        </div>
      }


      <div class="col-12">
        <label>Company Roles</label>
      </div>
      @for (role of $rolesToDisplay|async; track role) {
        <div class="col-12">
          <p-select [options]="$companies|async" [(ngModel)]="role.companyId"
            placeholder="Select a Company" [style]="{'width':'300px'}" [disabled]="true"></p-select>
        </div>
        <div class="col-5">
          <p-selectButton [options]="roles" [(ngModel)]="role.role"
            [disabled]="!isAuthenticatedUserACompanyAdmin2( ($authenticatedUser | async), role.companyId)"></p-selectButton>
        </div>
        @if (isAuthenticatedUserACompanyAdmin2(($authenticatedUser | async), role.companyId)) {
          <div class="col-7 flex align-items-start">
            <p-button class="p-button-secondary" icon="far fa-trash-alt" (click)="deleteRole(role)"></p-button>
          </div>
        }
        @if (modelInvalid && (!role.companyId || !role.role)) {
          <div class="col-12">
            <label style="color:red; font-weight:bold;">Company and Role is required!</label>
          </div>
        }
      }



      <div class="col-12">
        @if ($canAddCompanyRole|async) {
          <p-button icon="pi pi-plus" label="Company Role"
            (click)="addDisplayedCompanyRole()">
          </p-button>
        }
      </div>



      <!-- Action Buttons -->
      <div class="col-12">
        @if (isNew) {
<button pButton class="col-12 ui-md-3 ui-button-primary" (click)="saveUser()" [ngClass]="{ 'action-button': !saving,
                             'action-button-disabled': saving }" [disabled]="saving">Create
          </button>
        }
        @if (!isNew) {
<button pButton class="col-12 ui-md-3 ui-button-primary" (click)="saveUser()" [ngClass]="{ 'action-button': !saving,
                             'action-button-disabled': saving }" [disabled]="saving">Update
          </button>
        }
        @if (isAuthenticatedUserGlobalAdmin | async) {
          <button pButton class="col-12 ui-md-3 p-button-danger" (click)="confirmDelete()"
            [ngClass]="{ 'action-button': !saving,
                             'action-button-disabled': saving }" [disabled]="saving || isNew">Delete
          </button>
        }
        <button pButton class="col-12 ui-md-3 action-button p-button-secondary " (click)="returnToUserList()"
          >Cancel
        </button>
      </div>
    </ng-container>
  </div>


  <!--Invalid Model Dialog-->
  <p-dialog header="Cannot Save Changes" [(visible)]="showModelInvalidDialog" [modal]="true"
    [style]="{width: '350px'}" [minY]="70" [baseZIndex]="999" [autoZIndex]="false" [dismissableMask]="true">
    <span>
      One or more fields is empty or invalid. Please correct and try again.
    </span>
    <p-footer>
      <button type="button" pButton (click)="closeInvalidModelDialog()">
        <i pButtonIcon class="fa-check"></i>
        <span pButtonLabel>Ok</span>
      </button>
    </p-footer>
  </p-dialog>
